import { color, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { AddonContainer } from "./AddonContainer";
import isPropValid from "@emotion/is-prop-valid";
export const Input = styled.input.withConfig({
    shouldForwardProp: isPropValid,
}) `
  background: transparent;
  outline: none;
  border: none;
  flex-grow: 1;
  min-width: 0;
  font-size: ${size.font.base.default};

  box-sizing: border-box;

  line-height: ${size.lineHeight.text.default};
  // subtract border height from padding to get correct height
  padding: calc(${spacing.insetSquish.m.y} - 1px) ${spacing.insetSquish.m.x};

  &:-webkit-autofill,
  &:-webkit-autofill::first-line {
    line-height: ${size.lineHeight.text.default};
  }

  &:-webkit-autofill {
    // hacks the autofill background color
    // see https://css-tricks.com/snippets/css/change-autocomplete-styles-webkit-browsers/
    box-shadow: 0 0 0 1000px ${color.background.input.autofill} inset;
    // Just for Safari
    -webkit-text-fill-color: ${color.font.text.default};
    border-radius: 1px;
    // The icon should also use the autofill background
    & ~ ${AddonContainer} {
      background: ${color.background.input.autofill};
    }
  }

  &::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }

  // Just for Firefox (uses "detect-autofill")

  &[autocompleted] {
    filter: unset;
    background-color: ${color.background.input.autofill} !important;

    & + ${AddonContainer} {
      background: ${color.background.input.autofill};
    }
  }

  &:disabled,
  &.disabled {
    cursor: not-allowed;
  }

  &::placeholder {
    color: ${color.font.input.placeholder};
    // Just for you Safari
    line-height: normal !important;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5wdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0RmllbGQvc3R5bGVkL0lucHV0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDTCxLQUFLLEVBQ0wsSUFBSSxFQUNKLE9BQU8sR0FDUixNQUFNLGdEQUFnRCxDQUFDO0FBQ3hELE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQUNsRCxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUVqRCxNQUFNLENBQUMsTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxVQUFVLENBQUM7SUFDM0MsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQUE7Ozs7OztlQU1hLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87Ozs7aUJBSXBCLElBQUksQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLE9BQU87O2tCQUUzQixPQUFPLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLFdBQVcsT0FBTyxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQzs7OzttQkFJeEQsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsT0FBTzs7Ozs7OytCQU1oQixLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUssQ0FBQyxRQUFROzsrQkFFL0IsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTzs7O1VBRzVDLGNBQWM7b0JBQ0osS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsUUFBUTs7Ozs7Ozs7Ozs7Ozs7Ozs7O3dCQWtCM0IsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsUUFBUTs7VUFFN0MsY0FBYztvQkFDSixLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUssQ0FBQyxRQUFROzs7Ozs7Ozs7O2FBVXRDLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLFdBQVc7Ozs7Q0FJeEMsQ0FBQyJ9